import { Pipe, PipeTransform } from '@angular/core';
/**
  Converts From snake_case to Capitalized Words
*/
@Pipe({
  name: 'capitaliseWords'
})
export class CapitaliseWordsPipe implements PipeTransform {

  transform(value: string): string {
    if (!value) return value;
    return value
      .toLowerCase()
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
}
